(function(window, renderLibViewFactory) {
   'use strict';

   var namespace = window.TSC = window.TSC || {};
   namespace.RenderLibView = renderLibViewFactory(window, window.Q, window.tscrl, namespace.playerConfiguration);
})(this, function(window, Q, tscrl, playerConfiguration) {
   'use strict';

   var _hasRegisteredFileResolvers = false;

   var RenderLibView = function(mediaLibProject, theme) {
      var _rootElement = null;
      var _readyDefer = Q.defer();
      var _metadataDefer = Q.defer();
      var _canPlayDefer = Q.defer();
      var _rootBoundingClientRect;
      var supportedMimeTypes = ['video/mp4', 'image/png', 'image/jpg', 'image/jpeg', 'image/gif'];
      var renderLibProjectView = null;

      var createView = function() {
         renderLibProjectView = tscrl.ProjectView.create(supportedMimeTypes);
         renderLibProjectView.on('ready', onReady);
         renderLibProjectView.on('error', onError);
         renderLibProjectView.on('loadedmetadata', loadedMetadataCallback);
         renderLibProjectView.on('canplay', canplayCallback);
         renderLibProjectView.theme = theme;
         renderLibProjectView.seamlessScenePlayback = true;
         renderLibProjectView.src = mediaLibProject;
         renderLibProjectView.addEventListener = addEventListener;
         renderLibProjectView.removeEventListener = removeEventListener;

         renderLibProjectView.videoWidth = window.innerWidth;
         renderLibProjectView.videoHeight = window.innerHeight;

         _rootElement = renderLibProjectView.element;
      };

      var onReady = function() {
         renderLibProjectView.canvasNeedsResizing();
         watchForSizeChanges(_rootElement, 100);
         _readyDefer.resolve();
      };

      var onError = function() {
         _readyDefer.reject();
      };

      var loadedMetadataCallback = function() {
         _metadataDefer.resolve();
      };

      var canplayCallback = function() {
         _canPlayDefer.resolve();
      };

      var addEventListener = function(eventName, eventHandler) {
         renderLibProjectView.on(eventName, eventHandler);
      };

      var removeEventListener = function(eventName, eventHandler) {
         renderLibProjectView.off(eventName, eventHandler);
      };

      var watchForSizeChanges = function(watchedElement, millisecondInterval) {
         _rootBoundingClientRect = watchedElement.getBoundingClientRect();

         var callback = function() {
            var currentBoundingClientRect = watchedElement.getBoundingClientRect();
            if (currentBoundingClientRect.width !== _rootBoundingClientRect.width || currentBoundingClientRect.height !== _rootBoundingClientRect.height) {
               _rootBoundingClientRect = currentBoundingClientRect;
               renderLibProjectView.canvasNeedsResizing();
            }
         };

         setInterval(callback, millisecondInterval);
      };

      var width = function() {
         return window.innerWidth;
      };

      var height = function() {
         return window.innerHeight;
      };

      var bind = function() {
         if (arguments.length === 1) {
            if (typeof arguments[0] === 'object') {
               var obj = arguments[0];
               Object.keys(obj).forEach(function(key) {
                  addEventListener(key, obj[key]);
               });
            }
         } else if (arguments.length === 2) {
            if (typeof arguments[0] === 'string' && typeof arguments[1] === 'function') {
               addEventListener(arguments[0], arguments[1]);
            }
         }
      };

      var unbind = function() {
         if (arguments.length === 1) {
            var obj = arguments[0];
            if (typeof arguments[0] === 'object') {
               Object.keys(obj).forEach(function(key) {
                  removeEventListener(key, obj[key]);
               });
            }
         } else if (arguments.length === 2) {
            if (typeof arguments[0] === 'string' && typeof arguments[1] === 'function') {
               removeEventListener(arguments[0], arguments[1]);
            }
         }
      };

      var initialize = function() {
         var webConnector = playerConfiguration.getWebConnector();
         if (webConnector) {
            if (!_hasRegisteredFileResolvers) {
               var tscrlResolver = {
                  id: 'webConnectorFileResolver',
                  canResolve: function(sourceUrn) {
                     return webConnector.hasModuleByUrn(sourceUrn, 'resolver').then(function() {
                        return true;
                     }).catch(function() {
                        return Q(false);
                     });
                  },
                  getUri: function(sourceUrn) {
                     return webConnector.hasModuleByUrn(sourceUrn, 'resolver').then(function(resolver) {
                        return resolver.getFileUrl(sourceUrn);
                     }).catch(function() {
                        return Q.defer().reject('webConnectorFileResolver: could not find file resolver for sourceUrn(' + sourceUrn + ')');
                     });
                  }
               };

               tscrl.UriBuilder.registerFileResolver(tscrlResolver);

               _hasRegisteredFileResolvers = true;
               createView();
            } else {
               createView();
            }
         } else {
            throw Error('RenderLibView: webconnector player configuration is not loaded and is required to playback tscproj files');
         }
      };

      initialize();

      return Object.defineProperties({
         width: width,
         height: height,
         bind: bind,
         unbind: unbind
      }, {
         element: {
            get: function() {
               return _rootElement;
            }
         },
         ready: {
            get: function() {
               return _readyDefer.promise;
            }
         },
         metadataReady: {
            get: function() {
               return _metadataDefer.promise;
            }
         },
         canPlayReady: {
            get: function() {
               return _canPlayDefer.promise;
            }
         },
         view: {
            get: function() {
               return renderLibProjectView;
            }
         }
      });
   };

   return {
      create: RenderLibView
   };
});
